/*
 * Grid
 */
import Col from './Col';
import Row from './Row';
var Grid = {
  Row: Row,
  Col: Col
};
export * from './interface';
export default Grid;
export { Row, Col };